import { Progress, type ProgressProps } from '@chakra-ui/react';

export type UiProgressProps = ProgressProps;

export const UiProgress = Progress;
